import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./style.sass";
import { Button, Container, Card } from "react-bootstrap";
import { FaMailBulk } from "react-icons/fa";

const ConfirmSignup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
//   const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  useEffect(async () => {
    await confirmAccount();
  }, [searchParams]);

  async function confirmAccount() {
    if (searchParams.get("username") && searchParams.get("code")) {
      try {
        console.log("Inside function")
        const user = await Auth.confirmSignUp(
          searchParams.get("username"),
          searchParams.get("code")
        );
        console.log("User is : ", user)
        if (user === "SUCCESS") {
          setMessage(
            "Your account has been confirmed. Please login to continue. You will be redirected in few seconds"
          );
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        }
      } catch (error) {
        console.log("Error is : ", error)
        setMessage(error?.message);
      }
    } else {
      setMessage(
        "There was an error confirming your account. Please try again."
      );
    }
  }

  return (
    <Container className={"signin-div"} fluid>
      <Card className="confirm-card">
        {" "}
        {/* Add your custom CSS class here */}
        <Card.Body className="text-center">
          <FaMailBulk size={"5em"} />
          <Card.Text className="text-black mt-3">{message}</Card.Text>
          <Button className="btn-dark" onClick={() => navigate("/login")}>
            Back to login
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ConfirmSignup;
